import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import sweetAlert from 'sweetalert'

const initialState = {
    milestoneCollectionTemp: []
}
export default class Mcqlist extends Component {

    constructor(props) {
        super(props)
        this.state = {
            view_option: "LIST",     //EDIT, DELETE, CREATE
            milestoneCollectionTemp: [],
            ProductsMilestone: [],
            modulesNo: 0,
            dummyModulesize: [],
            select: 1,
            input: ""


        }
    }
    componentDidMount() {
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        this.setState({ courseId: lastItem }, () => {
            this.getAllMilestone();

        })
    }


    getAllMilestone = () => {
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/fetch_milestone/`;
        const params = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                courseId: this.state.courseId,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    if (data.ProductsMilestone.milestone_collection) {
                        this.setState({ ProductsMilestone: data.ProductsMilestone.milestone_collection, modulesNo: data.ProductsMilestone.modulesNo, dummyModulesize: new Array(data.ProductsMilestone.modulesNo).fill("") })
                    }
                }
            })
    }
    addMilestone = () => {
        let ProductsMilestone = this.state.ProductsMilestone;
        let _obj = this.state.ProductsMilestone.findIndex(x => x.m_no == this.state.select)
        if (_obj == -1) {
            ProductsMilestone.push({ m_no: this.state.select, m_name: this.state.input })
        } else {
            ProductsMilestone[_obj] = { m_no: this.state.select, m_name: this.state.input }
        }
        ProductsMilestone.sort(function(a, b) {
            return a.m_no - b.m_no;
        });

        this.setState({ ProductsMilestone, input: "" })
    }
    saveResult = () => {
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/update_milestone/`;
        const params = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                courseId: this.state.courseId,
                milestone_collection: this.state.ProductsMilestone
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    toast.success("Successfully Updated !")
                    setTimeout(() => {
                        this.props.history.push('/products/digital/digital-product-list');
                    }, 3000);
                } else {
                    toast.success("Please Retry !")
                }
            })
    }
    remove = (index) => {
        let obj = this.state.ProductsMilestone;
        obj.splice(index, 1)
        this.setState({ ProductsMilestone: obj })
    }
    render() {
        return (
            <Fragment>
                <Breadcrumb title={`Milestone`} parent="Milestone" />
                <ToastContainer />
                <br />
                <div class="input-group mb-3">
                    <div class="form-group">
                        {/* <label class="input-group-text" for="inputGroupSelect01"> Add Milestones</label> */}
                        <button type="button" onClick={this.saveResult} class="btn btn-primary float-right">Save</button>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">Milestone Name</span>
                        </div>
                        <input type="text" class="form-control" onChange={(e) => this.setState({ input: e.target.value })} value={this.state.input} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
                    </div>

                    <div class="input-group">
                        <select class="custom-select" id="inputGroupSelect04" aria-label="Example select with button addon" onChange={(e) => this.setState({ select: Number(e.target.value) })}>
                            {this.state.dummyModulesize.map((list, index) => <option value={index + 1}>{index + 1}</option>)}

                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" onClick={this.addMilestone} type="button">{this.state.ProductsMilestone.findIndex(x => x.m_no == this.state.select) == -1 ? "Add Milestone" : "Update Milestone"} </button>
                        </div>
                    </div>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Milestone No</th>
                            <th scope="col">Milestone Name</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.ProductsMilestone.map((list, index) =>
                            <tr>
                                <th scope="row">{list.m_no}</th>
                                <td>{list.m_name}</td>
                                <td> <i onClick={() => this.remove(index)} className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}></i></td>
                            </tr>
                        )}


                    </tbody>
                </table>
            </Fragment>
        )
    }
}
